// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon-download[data-v-4897cfee] {\n  margin-bottom: 10px\n}\n.custom-table[data-v-4897cfee] {\n  width: 98.5%;\n  margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
